import { define, useEffect, useRef } from "hooked-elements";
import logEvent, { FIRST_SCROLL_INFOS, SCROLL } from "../analytics/logEvent";
import { isClient } from "../utils/dev";
import useScrollTrigger from "../utils/useScrollTrigger";

export default () =>
  define("body", () => {
    const trigger = useScrollTrigger({
      threshold: isClient ? window.innerHeight / 3 : 300,
    });
    const count = useRef(0);
    useEffect(
      () =>
        trigger &&
        count.current++ === 0 &&
        logEvent({
          category: FIRST_SCROLL_INFOS,
          action: SCROLL,
        }),
      [count, trigger]
    );
  });
